var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMeta = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "768pt",
    height: "768pt",
    viewBox: "0 -768 768 768",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "LinearGradient",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 495.753,
    y2: -25.038,
    gradientTransform: "translate(180.08 396.398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0064e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400000005960464,
    stopColor: "#0064e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830000042915344,
    stopColor: "#0073ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "LinearGradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 182.779,
    gradientTransform: "translate(127.721 275.089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0082fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064e0"
  })), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url('https://themes.googleusercontent.com/fonts/css?family=Open Sans:400,600');"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    stroke: "none",
    strokeWidth: 0.301
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 101.769,307.74 C 101.769,280.247 107.801,259.142 115.69,246.373 C 126.032,229.646 141.455,222.546 157.18,222.546 C 177.459,222.546 196.013,227.58 231.766,277.031 C 260.418,316.667 294.162,372.301 316.872,407.18 L 355.331,466.27 C 382.046,507.308 412.968,552.926 448.423,583.848 C 477.376,609.088 508.59,623.11 540.012,623.11 C 592.77,623.11 643.021,592.537 681.479,535.199 C 723.569,472.405 743.999,393.307 743.999,311.685 C 743.999,263.158 734.435,227.504 718.158,199.337 C 702.438,172.097 671.789,144.878 620.236,144.878 L 620.236,222.559 C 664.379,222.559 675.393,263.123 675.393,309.543 C 675.393,375.694 659.97,449.103 625.993,501.559 C 601.883,538.767 570.636,561.5 536.257,561.5 C 499.075,561.5 469.155,533.452 435.527,483.458 C 417.649,456.891 399.297,424.519 378.689,387.986 L 356.003,347.8 C 310.439,266.989 298.895,248.592 276.11,218.228 C 236.176,165.051 202.072,144.889 157.18,144.889 C 103.923,144.889 70.247,167.952 49.39,202.704 C 32.364,231.021 24.001,268.181 24.001,310.518 Z",
    fill: "#0081fb",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85.321,529.728 C 120.974,584.686 172.429,623.122 231.444,623.122 C 265.62,623.122 299.603,613.006 335.076,584.035 C 373.885,552.368 415.247,500.193 466.853,414.24 L 485.355,383.402 C 530.024,308.987 555.436,270.705 570.31,252.651 C 589.438,229.468 602.833,222.556 620.236,222.556 C 664.378,222.556 675.393,263.119 675.393,309.541 L 743.999,311.694 C 743.999,263.168 734.435,227.514 718.158,199.345 C 702.438,172.106 671.789,144.888 620.236,144.888 C 588.186,144.888 559.794,151.848 528.396,181.471 C 504.268,204.204 476.038,244.589 454.331,280.895 L 389.758,388.758 C 357.361,442.891 327.629,483.252 310.439,501.532 C 291.933,521.19 268.148,544.926 230.189,544.926 C 199.469,544.926 173.378,523.368 151.547,490.392 Z",
    markerStart: "none",
    markerEnd: "none",
    fill: "url(#LinearGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230.189,544.926 C 199.469,544.926 173.378,523.368 151.547,490.392 C 120.673,443.796 101.784,374.391 101.784,307.74 C 101.784,280.247 107.816,259.142 115.706,246.373 L 49.39,202.704 C 32.364,231.021 24.001,268.181 24.001,310.518 C 24.001,387.51 45.134,467.757 85.321,529.728 C 120.974,584.686 172.429,623.12 231.444,623.12 Z",
    markerStart: "none",
    markerEnd: "none",
    fill: "url(#LinearGradient_1)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMeta);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-meta.a0f06a43eb96310c5e34965b88938b3a.svg";